/**
 * Scroll Reveal — subtle fade-up animation for sections as they enter the viewport.
 * Uses IntersectionObserver for performance. Respects prefers-reduced-motion.
 */

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!REDUCED_MOTION) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-revealed');
          observer.unobserve(entry.target);
        }
      }
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observeSections() {
    const sections = document.querySelectorAll(
      '.section-wrapper:not(.hero-wrapper):not(.scroll-revealed)'
    );
    for (const section of sections) {
      section.classList.add('scroll-reveal');
      observer.observe(section);
    }
  }

  // Observe on load
  observeSections();

  // Re-observe after Shopify section rendering (dynamic sections)
  document.addEventListener('shopify:section:load', observeSections);
}
